import React from "react";
import style from './Users.module.css';

let User = (props) => {
    return (
        <div className={style.usersBox}>
            <div className={style.userCard}>
                <div className={style.userImgContainer}>
                    <img src={props.avatar} alt="avatar"/>
                </div>
                <div>{props.name}</div>
                <div>{props.followed}</div>
                <div>{props.since}</div>
                <div>
                    {props.followed
                        ? <button onClick={() => {props.followUser(props.id)}}>Unfollow</button>
                        : <button onClick={() => {props.unfollowUser(props.id)}}>Follow</button>
                    }
                </div>

            </div>
        </div>
    )
}

export default User;